<script setup lang="ts">
import store from '@/store'
import { ERoleActions } from '@/store/roleStore/RoleStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { defaultRoleModel, type RoleModel } from '@/types/models/RoleModel'
import { EAdminPerm } from '@/types/permissions/AdminPermissionsEnum'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AdministrationRoleDetailView from '../AdministrationRoleDetailView.vue'

const route = useRoute()
const roleId = ref(route.params.id.toString())
const isLoading = ref(false)

const data = ref<Partial<RoleModel>>({ ...defaultRoleModel })
const getRole = () => {
    isLoading.value = true
    store
        .dispatch(`${EStoreModules.ROLE}/${ERoleActions.FETCH_ROLE}`, roleId.value)
        .then(res => (data.value = res))
        .finally(() => (isLoading.value = false))
}

onMounted(() => {
    if (typeof roleId.value === 'string') getRole()
})

const save = () => {
    isLoading.value = true
    store
        .dispatch(`${EStoreModules.ROLE}/${ERoleActions.UPDATE_ROLE}`, {
            roleId: roleId.value,
            roleData: data.value
        })
        .then(() => getRole())
        .finally(() => (isLoading.value = false))
}

const updateRole = (value: Partial<RoleModel>) => (data.value = { ...data.value, ...value })
</script>

<template>
    <AdministrationRoleDetailView
        :data="data"
        :buttonLabel="$t('common.saveModifications')"
        :editPermission="EAdminPerm.ADMIN_ROLES"
        :loading="isLoading"
        @click="save"
        @update="updateRole" />
</template>
